<div class="query-properties-container">
  <div class="header">
    <p>{{ translation?.title }}</p>
  </div>
  <div class="body">
    <div class="form-wrapper">
      <div class="form-filed">
        <abc-drop-down-box
          [width]="'100%'"
          [visible]="query.parentNode.parentId ? false : true"
          label="{{ translation?.objectType }}"
          [value]="query.data.name"
          (onValueChanged)="changeQueryObjectType($event)"
          #objectTypeInfoDropDown
        ></abc-drop-down-box>
      </div>
      <div class="form-filed">
        <div class="open-opath-expression-container">
          <abc-text-box
            #expressionTextBox
            [width]="'100%'"
            label="{{ translation?.expression }}"
            [value]="query.data.expression"
            [buttons]="expressionTextBoxButtons"
            (onValueChanged)="handleExpressionChanged($event)"
          ></abc-text-box>
        </div>
      </div>
      <div class="form-filed">
        <div class="alias-container">
          <abc-text-box
            [width]="'75%'"
            [valueChangeEvent]="'input'"
            label="{{ translation?.alias }}"
            [(value)]="query.data.alias"
            (onValueChanged)="changeAlias($event)"
          ></abc-text-box>
          <div class="duplicates-check-box">
            <abc-check-box
              id="check-box"
              [(value)]="query.data.queryProperties.isDuplicated"
              (onValueChanged)="refresh()"
            ></abc-check-box>
            <label>{{ translation?.noDuplicates }}</label>
          </div>
        </div>
      </div>
      <div class="rows-number-container">
        <abc-number-box
          [showSpinButtons]="true"
          [width]="'100%'"
          [min]="0"
          label="{{ translation?.skipNumberOfRows }}"
          [(value)]="query.data.queryProperties.skippedRowsNbr"
          (onValueChanged)="refresh()"
        ></abc-number-box>
        <abc-number-box
          [showSpinButtons]="true"
          [width]="'100%'"
          [min]="0"
          [(value)]="query.data.queryProperties.limitRowsNbr"
          (onValueChanged)="refresh()"
          label="{{ translation?.limitNumberOfRows }}"
        ></abc-number-box>
        <abc-drop-down-box
          label="{{ translation?.subQueryKind }}"
          placeholder="{{ translation?.subQueryKind }}"
          [visible]="query.parentNode.parentId ? true : false"
          [(value)]="query.data.queryProperties.subQueryKind"
          (onValueChanged)="refresh()"
          [width]="'100%'"
          #subQueryKindDropDownBox
        ></abc-drop-down-box>
      </div>
    </div>
    <div class="column-label">
      <span>{{ translation?.gridTitle }}</span>
      <div class="separation"></div>
    </div>
    <div class="grid-container">
      <abc-grid
        #grid
        [dataSource]="gridDataSource"
        [syncLookupFilterValues]="false"
        [remoteOperations]="false"
        [allowColumnReordering]="true"
        [rowAlternationEnabled]="true"
        [setupDefaultLayoutOnInitialization]="true"
        [headerFilter]="{ visible: false }"
        [showBorders]="false"
        [width]="'100%'"
        [height]="'100%'"
        [columns]="columns"
        (onFocusedCellChanged)="handleRowIndex($event)"
        (onRowUpdated)="updateRow($event)"
        (onEditorPreparing)="lookupNotEditable($event)"
      >
      </abc-grid>
    </div>
  </div>
</div>
